import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingServiceStoreIds } from '../../api/charging-service.ts';
import { UpdateChargingServiceStoreIdsRequest } from '../../api/requests/charging-service-request.ts';

export default function useUpdateChargingServiceStoreIds(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingServiceStoreIds>>,
  Error,
  UpdateChargingServiceStoreIdsRequest
> {
  return useMutation({
    mutationFn: updateChargingServiceStoreIds,
  });
}
